import SpriteImage from "@PUBLIC/M/images/btn/btn_spr.png";
import styled from "@yb/styled-px2rem";

const CheckList = styled.ul`
	display: flex;
	flex-wrap: wrap;
	flex: 1 1 auto;
	gap: 10px;
	width: 100%;
	li {
		label {
			padding: 10px 15px;
		}
		input {
			&:checked + label {
				display: flex;
				align-items: center;
				gap: 10px;
				&::after {
					transform: translateY(-14%) rotate(45deg);
				}
			}
		}
	}
`;
const CheckListItem = styled.li`
	position: relative;
	input {
		position: absolute;
		top: 0;
		left: 0;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: 0;
		background-color: transparent;
		border: 0;

		&:checked {
			+ label {
				font-weight: bold;
				border-color: var(--emp-color);
				color: var(--emp-color);
				&::after {
					display: block;
					flex: 0 0 auto;
					width: 6px;
					height: 11px;
					border-right: 0.15rem solid var(--emp-color);
					border-bottom: 0.15rem solid var(--emp-color);
					content: "";
				}
			}
		}

		+ label {
			display: inline-flex;
			width: 100%;
			padding: 10px 15px;
			border: 1px solid var(--line-color);
			border-radius: 8px;
			background-color: #fff;
			box-sizing: border-box;
			overflow: hidden;
		}
	}
`;

const IconButton = styled.button`
	position: absolute;
	left: 15px;
	top: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	border: 1px solid var(--line-color);
	transform: translateY(-50%);

	&::before {
		display: block;
		width: 16px;
		height: 16px;
		background: url(${SpriteImage}) no-repeat;
		background-size: 100px 100px;
		background-position: -15px -15px;
		content: "";
	}
`;

export {CheckList, CheckListItem, IconButton};
